import React, {Component} from 'react';
import {action, observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import _ from "underscore";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  FormSelect,
  FormInput,
  ButtonGroup,
  Button,
  FormCheckbox,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  FormRadio
} from "shards-react";
//https://designrevision.com/docs/shards-react/getting-started
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ChromePicker} from "react-color";
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import HelpButton from "../../../components/common/HelpButton";
import guideManager from "../../../guides/guideManager";
import { hasTour } from "../../../guides/tourRegistry";
import FeatherIcon from 'feather-icons-react';
import moment from "moment";
import ModalLoading from "../../../components/common/ModalLoading";
import boardDataCheckImg from "../../../images/board_data_check.png";

let initSetting = {
  writer: '',
  password: '',
  isAutoWrite: false,
  isShowWriterName:  false,
  isShowProductName: false,
  sentencesNum: '2~3',
  autoReplyStartTime: 9,
  autoReplyEndTime: 18,
  autoReplyFrequency: 3,
  autoRunTimes: [],
  atmosphere: ['', '', ''],
  reviewRatingConfigs: [
    { isAutoWrite: true, rating: '1_20', type: 'na', isShowWriterName:false, isShowProductName: false, tone: ''},
    { isAutoWrite: true, rating: '21_40', type: 'fixed', isShowWriterName:false, isShowProductName: false, tone: '안녕하세요. [구매자명]님. [상품명]리뷰 작성 감사합니다. \n' +
          '[상품별 추가 내용]' +
          '고객님의 소중한 리뷰는 저희에게 큰 힘이 됩니다. 앞으로도 더욱 좋은 상품으로 보답하겠습니다.'},
    { isAutoWrite: true, rating: '41_100', type: 'ai', isShowWriterName:true, isShowProductName: true, tone: '안녕하세요. 고객님. 리뷰 작성 감사합니다. 고객님의 소중한 리뷰는 저희에게 큰 힘이 됩니다. 앞으로도 더욱 좋은 상품으로 보답하겠습니다.'},
  ],
  defaultColor: "#000000",
  themeColor: "#121212",
  subColor: "#6255F6",
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};


function isOverPeriod(date1, date2, periodArr) {
  const startDate = moment(date1);
  const endDate = moment(date2);
  const periodDiff = endDate.diff(startDate, periodArr[1]);
  return periodDiff <= periodArr[0];
}

@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me, getMe:teamUser.getMe }))
@inject(({ company }) => ({ updateStore:company.updateStore, getApplySkins:company.getApplySkins, getApplyShop:company.getApplyShop, applyAllSkin:company.applyAllSkin, applySkin:company.applySkin}))
@inject(({ product }) => ({ getProductList: product.getProductList, setProductSync: product.setProductSync }))
@inject(({ review }) => ({ setReviewSync: review.setReviewSync, getStatusReviewBoard: review.getStatusReviewBoard }))

@observer
class ReviewWriteConfig extends Component {

  //basic
  @observable teamUser = {};
  @observable permissions = {}
  @observable store = {};
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = false;

  //page
  @observable isShowMColor_1 = false;
  @observable isShowMColor_2 = false;
  @observable isShowMColor_3 = false;
  @observable colorPickerPos = { top: 0, left: 0 };
  //카테고리 정보와 상품 정보 샵에서 가져와야함.
  @observable setting = initSetting;
  @observable skins = [];
  @observable shops = [];
  @observable selShop = {};
  @observable syncReviewValue = {
    startDate: moment().add(-1, 'days').format('yyyy-MM-DD'),
    endDate: moment().format('yyyy-MM-DD'),
    isOverwrite: false,
  };

  @observable reviewWrightLimit = {
    store_id: null,
    isUseNormalReview: true,
    // isUseSnsReview: false,
    isUseNoPurchase: false,
    noPurchaseFields: {
      phone: 'required',
      email: 'optional',
      purchaseChannel: 'required',
      purchaseChannelOptions: ['오프라인매장', 'SNS', '지인 선물', '기타']
    }
  }

  @observable newPurchaseChannelOption = '';

  // 첫 진입 시 펼치는 아코디언
  @observable openRwcSection = 'detailWidget';

  @action toggleRwcAccordion = (key) => {
    this.openRwcSection = this.openRwcSection === key ? null : key;
  };

  // basicSettings 변경 추적 — sticky-save 바 노출 조건
  @observable basicSettingsDirty = false;

  @observable basicSettings = {
    writer: '',
    password: '',
    store_id: null,
    minChars: 10,
    maxChars: 5000,
    mainPhase: [],
    subPhase: [],
    productDetailUrlType: 'easy', // 'easy' | 'basic'
    writeEnabledState: 1,
    writeEnabledDate: 50,
    isDeliveryRating: false,
    pendingRatingThreshold: '', // '', 'all', '5', '4', '3', '2' — 별점 기준 대기 처리
    isOrderConfirmOnReview: false,
    defaultColor: "#000000",
    themeColor: "#121212",
    ratingMarkColor: "#121212",
    subColor: "#6255F6",
    isNoDisProductReview: false,
    writerDisType: 1,
    perListCount: 5,
    listSortType: 'newst',
    widgetCssUrl: '',
    productReviewWidgetConfig: {
      parentSelector: "",
      insertPosition: "append",
      maxWidth: "100%",
      marginTop: "0px",
      marginBottom: "0px",
      lrPadding: "0px"
    },
    // AI 리뷰 키워드 인사이트 (상품 상세 product_list 위젯 노출)
    aiKeywordsConfig: {
      enabled: false,         // opt-in
      displayCount: 7,        // 5 / 7 / 10
      showSummary: true,      // analysis 한줄 요약 카드
      enableFilter: true,     // 칩 클릭 인라인 리뷰 필터
      themeBg: 'theme-0'      // theme-0 ~ theme-5
    }
  };

  // 제품 리스트(카테고리) 페이지 설정 — widgetByPage에서 이전됨
  // 상세페이지 별점 및 리뷰수 (reviewRatingCount/reviewRatingCountConfig) — widgetByPage 에서 이전됨
  @observable metaWidget = {
    store_id: null,
    productMetaType: "no",
    productMetaTypeAlign: "no",
    productListConfig: {
      marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      parentSelector: "", parentSelectorMobile: "", insertPosition: "append",
      productListClass: "", productListClassMobile: ""
    },
    reviewRatingCount: "no",
    reviewRatingCountConfig: {
      maxWidth: "100%", marginTop: "0px", marginBottom: "0px", lrPadding: "0px",
      parentSelector: "", insertPosition: "append"
    }
  };
  @observable metaWidgetDirty = false;

  @observable serarchPeriod = [3, "months", "3개월 단위"];
  @observable newMainPhase = '';
  @observable newSubPhase = '';

  @observable reviewFiltering = {
    store_id: null,
    isRecmFilter: false,
    filterWords: []
  };
  // @observable isRecmFilter = {
  //   isUse: false
  // }
  @observable filterWords = [];
  @observable newFilterWord = { block: '', alter: ''};

  //modals
  @observable isWidgetMode = false;
  @observable isShowCalendar = {
    startDate: false,
    endDate: false
  }
  @observable isShowCalendarForRS = {
    startDate: false,
    endDate: false
  }
  @observable modals = {
    cafeSettingData: {},
    isCafeSettingModal: false,
    isBoardCapacityGuide: false
  };

  // @observable reviewAutoReply = {
  //   store_id: null,
  //   isUse: false,
  //   displayTime: 30,
  //   replyContents: []
  // }

  // @observable newReplyContents = {
  //   grade: null,
  //   text: ''
  // };

  constructor(props) {
    super(props);
    this.init()
  }

  componentDidMount() {
    // 페이지 가이드 — 첫 방문 시 1회 자동 시작(미열람 시). 폼 렌더 후 약간 지연.
    setTimeout(() => guideManager.maybeAutoStart('reviewWriteConfig', { storeId: this.store && this.store._id }), 600);
  }

  // 섹션별 세부 가이드 — 박스의 ? 클릭 시: 섹션을 펼치고 그 섹션 가이드 실행(페이지 가이드와 별개).
  @action openSectionGuide = (sectionKey) => {
    this.openRwcSection = sectionKey;                 // 항목이 보여야 부착 가능 → 펼치기
    const storeId = this.store && this.store._id;
    setTimeout(() => guideManager.startGuide('reviewWriteConfig:' + sectionKey, { storeId }, { force: true }), 350);
  };

  // 박스 헤더용 ? — 해당 섹션 가이드가 등록돼 있을 때만 렌더.
  renderSectionHelp = (sectionKey) => {
    if (!hasTour('reviewWriteConfig:' + sectionKey)) return null;
    return (
      <button type="button" className="wbp-accordion__help" title="이 설정 가이드 보기" aria-label="이 설정 가이드 보기"
              onClick={(e) => { e.stopPropagation(); this.openSectionGuide(sectionKey); }}>
        <FeatherIcon icon="help-circle" size="15"/>
      </button>
    );
  };


  @action
  init = async (key) => {
    let _this = this;
    if(this.props.isLogin) {
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.teamUser.store;
      console.log(this.store);
      this.permissions = this.props.me.permissions;
      this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
        if(res.errors && res.errors.length > 0) {
          alert(res.errors[0].message);
        }
        else {
          let results;
          if(res) {
            results = res;
            if(results.basicSettings) {
              let getSettings = _.pick(results.basicSettings, 'writer', 'password', 'replyTyep', 'store_id', 'minChars', 'maxChars',
                  'mainPhase', 'subPhase', 'writeEnabledState', 'writeEnabledDate', 'isDeliveryRating', 'pendingRatingThreshold', 'isOrderConfirmOnReview', 'productReviewInfoType', 'reviewDetailV',
                  'defaultColor', 'themeColor', 'ratingMarkColor', 'subColor', 'isNoDisReviewDate', 'isNoDisReviewWriter', 'writerDisTextCount', 'isNoDisProductReview', 'writerDisType', 'perListCount', 'listSortType', 'widgetCssUrl', 'productReviewWidgetConfig', 'productDetailUrlType', 'aiKeywordsConfig');
              _this.basicSettings = {..._this.basicSettings , ...getSettings};
              // aiKeywordsConfig 부분 객체 안전망 — 일부 필드만 저장된 store 도 5필드 default 보장
              _this.basicSettings.aiKeywordsConfig = _.defaults(
                {},
                _this.basicSettings.aiKeywordsConfig || {},
                { enabled: false, displayCount: 7, showSummary: true, enableFilter: true, themeBg: 'theme-0' }
              );
            }
            if(results.filtering) {
              _this.reviewFiltering = results.filtering;
              _this.filterWords = results.filtering.filterWords;
            }
            if(results.writeLimit) {
              _this.reviewWrightLimit = results.writeLimit;
            }
            if(!_this.reviewWrightLimit.noPurchaseFields) {
              _this.reviewWrightLimit.noPurchaseFields = {
                phone: 'required',
                email: 'optional',
                purchaseChannel: 'required',
                purchaseChannelOptions: ['오프라인매장', 'SNS', '지인 선물', '기타']
              };
            }
            _this.basicSettings.store_id = _this.teamUser.selStore_id;
            _this.basicSettings.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
            _this.reviewFiltering.store_id = _this.teamUser.selStore_id;
            _this.reviewFiltering.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;
            _this.reviewWrightLimit.store_id = _this.teamUser.selStore_id;
            _this.reviewWrightLimit.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1;

            if (results.metaWidget) {
              let mw = _.pick(results.metaWidget, 'productMetaType', 'productMetaTypeAlign', 'productListConfig', 'reviewRatingCount', 'reviewRatingCountConfig');
              mw.productListConfig = _.defaults({}, mw.productListConfig || {}, _this.metaWidget.productListConfig);
              mw.reviewRatingCountConfig = _.defaults({}, mw.reviewRatingCountConfig || {}, _this.metaWidget.reviewRatingCountConfig);
              _this.metaWidget = _.defaults(mw, _this.metaWidget);
            }
            _this.metaWidget.store_id = _this.teamUser.selStore_id;
            _this.metaWidgetDirty = false;
          }
        }
      });
      // let me = await this.props.getMe();


      this.getApplySkins(false);
      this.getApplyShop(false)

    }
  };

  onChangeInputs = async (event, targetObj) => {
    let { name, value } = event.target;
    let isPrg = true;
    if(targetObj) {
      if(name === 'writeEnabledDate') {
        if(value > 0 && value < 60) {

        }
        else {
          if(value === '' || value === null) {
            value = '';
          }
          else {
            alert('최소 1, 최대 60일까지 가능합니다.')
            isPrg = false;
          }

        }
      }

      if(isPrg) {
        targetObj[name] = value;
        if (targetObj === this.basicSettings) this.basicSettingsDirty = true;
        if(name === "cafe24UseReviewBoardNo") {
          let updateStore = {
            id: this.teamUser.store._id,
            cafe24UseReviewBoardNo: parseInt(value)
          }
          this.props.updateStore( updateStore, function(res) {
            if(res.errors && res.errors.length > 0) {
              toast(res.errors[0].message);
            }
            else {
              toast('업데이트가 완료 되었습니다.');
            }
          });
        }
      }
    }
  };

  nullCheck = async (event, targetObj, defalutValue) => {
    let { name, value } = event.target;
    if(value === '' || value === null) {
      value = defalutValue;
    }
    targetObj[name] = value;
  }

  onChangeMetaInputs = (event, targetObj) => {
    let { name, value } = event.target;
    if (targetObj && name) {
      targetObj[name] = value;
      if (targetObj === this.metaWidget) this.metaWidgetDirty = true;
    }
  };

  onChangeProductListConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (type === 'checkbox') this.metaWidget.productListConfig[name] = checked;
    else this.metaWidget.productListConfig[name] = value;
    this.metaWidgetDirty = true;
  };

  onChangeReviewRatingCountConfig = (event) => {
    const { name, value, type, checked } = event.target;
    if (!this.metaWidget.reviewRatingCountConfig) this.metaWidget.reviewRatingCountConfig = {};
    if (type === 'checkbox') this.metaWidget.reviewRatingCountConfig[name] = checked;
    else this.metaWidget.reviewRatingCountConfig[name] = value;
    this.metaWidgetDirty = true;
  };

  onChangeChecked = async (event, targetObj, keyArray) => {
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if (targetObj === this.basicSettings) this.basicSettingsDirty = true;
      if(keyArray[0] === 'isSetScript') {
        targetObj.id = targetObj._id;
        this.props.applySkin(targetObj, function(res) {
          if(res.errors && res.errors.length > 0) {
            alert(res.errors[0].message);
            targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
          else {
            toast('처리 되었습니다.');
            //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
          }
        });
      }
      else if(keyArray[0] === 'isRecmFilter') {
        this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
          if(res.errors && res.errors.length > 0) {
            toast(res.errors[0].message);
          }
          else {

          }
        });
      }
    }
  };

  @action
  getApplySkins = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      actSync: actSync
    }
    this.props.getApplySkins( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        _this.skins = res.data;
        if(actSync) {
          toast('업데이트가 완료 되었습니다.');
        }
      }
    });
  }

  @action
  getApplyShop = async (actSync) => {
    let _this = this;
    let updateStore = {
      store_id: this.teamUser.store._id
    }
    this.props.getApplyShop( updateStore, function(res) {
      if(res.errors && res.errors.length > 0) {
        //toast(res.errors[0].message);
      }
      else {
        _this.shops = _.indexBy(res.data, 'platformShopNo');
        _this.selShop = _this.shops[_this.teamUser.selShopNo];

      }
    });
  }

  onChangeCheckedforApplySkin = async (event, targetObj, keyArray) => {
    let _this = this;
    _this.isLoading = true;
    if(keyArray[0]) {
      targetObj[keyArray[0]] = !targetObj[keyArray[0]];
      if(this.teamUser.isPaidShop || !targetObj[keyArray[0]]) {
        if(keyArray[0] === 'isSetScript') {
          targetObj.id = targetObj._id;
          targetObj.shopNo = _this.teamUser.selShopNo ? _this.teamUser.selShopNo: 1;
          this.props.applySkin(targetObj, function(res) {
            if(res.errors && res.errors.length > 0) {
              alert(res.errors[0].message);
              targetObj[keyArray[0]] = !targetObj[keyArray[0]];
              _this.isLoading = false;
            }
            else {
              _this.isLoading = false;
              toast('처리 되었습니다.');
              //targetObj[keyArray[0]] = !targetObj[keyArray[0]];
            }

          });
        }
        else {
          _this.isLoading = false;
        }
      }
      else {
        _this.isLoading = false;
        targetObj[keyArray[0]] = false;
        let cf = window.confirm('주문 완료 후 이용 가능합니다. 주문 페이지로 이동하시겠습니까?');
        if(cf) {
          window.location.href = '/inAppOrder';
        }
      }
    }


  };

  // setReviewSync = async (type) => {
  //   let _this = this;
  //   //let confimRes = window.confirm("기존 온리플의 리뷰는 모두 삭제되고 카페24 리뷰로 대체 됩니다. 진행하시겠습니까?");
  //   _this.isLoading = true;
  //   let data = {
  //     store_id: _this.store._id,
  //     getType: type ? type : 'new',
  //
  //   }
  //   if(type === 'period') {
  //     if(isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
  //       data.params = this.syncReviewValue;
  //     }
  //     else {
  //       console.log(this.serarchPeriod)
  //       alert('최대 ' + this.serarchPeriod[3]  + '로 선택해 주세요.');
  //       return false;
  //     }
  //   }
  //
  //
  //   _this.props.setReviewSync(data, function(res) {
  //     if(res && res.data) {
  //       toast(moment(res.data.startDate).format('YYYY-MM-DD') + ' ~ ' + moment(res.data.endDate).format('YYYY-MM-DD') + ' 기간의 리뷰가 ' +  res.data.insertReviewCount + '개 업데이트 되었습니다.');
  //       if(res.data.insertReviewCount > 0) {
  //         _this.getReviewList();
  //       }
  //     }
  //     _this.isLoading = false;
  //   });
  //
  // };

  @action
  setProductSync = async (event) => {
    let _this = this;
    if(! await this.checkPaidUser(_this.store)) return false;

    _this.isLoading = true;
    let data = {
      store_id: _this.store._id,
      shopNo: _this.teamUser.selShopNo,
      teamUser_id: _this.teamUser.id,
    }

    _this.props.setProductSync(data, function(res) {
      _this.isLoading = false;
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast(res.data.productCount + "상품 동기화가 완료되었습니다.");
      }
    });

    for (let i = 0; i < localStorage.length; i++) {
      if(localStorage.key(i).indexOf("goodList_" + this.store.platformId) > -1 ) {
        localStorage.removeItem(localStorage.key(i));
      }
    }

  };

  @action
  selectPeriod = async (num, type) => {
    let _this = this;
    let selPeriod = [];
    selPeriod[0] = num;
    selPeriod[1] = type;

    if(type === "max") {
      let data = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        flatform: 'cafe24'
      }

      this.props.getStatusReviewBoard(data, function(res) {
        if(res && res.data) {
          console.log(res.data);
          _this.modals.data = res.data;
          if(res.data.selectPeriod[1] === "years") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "년";
          }
          else if(res.data.selectPeriod[1] === "months") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "달";
          }
          else if(res.data.selectPeriod[1] === "weeks") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "주";
          }
          else if(res.data.selectPeriod[1] === "days") {
            res.data.selectPeriod[2] = res.data.selectPeriod[0] + "일";
          }
          _this.serarchPeriod = res.data.selectPeriod;
          _this.syncReviewValue.startDate = moment().add(-res.data.selectPeriod[0], res.data.selectPeriod[1]).add(1, 'days').format('yyyy-MM-DD');
        }
      });
    }
    else {
      if(type === "years") {
        selPeriod[2] = num + "년";
      }
      else if(type === "months") {
        selPeriod[2] = num + "달";
      }
      else if(type === "weeks") {
        selPeriod[2] = num + "주";
      }
      else if(type === "days") {
        selPeriod[2] = num + "일";
      }
      this.serarchPeriod = selPeriod;
      this.syncReviewValue.startDate = moment().add(-selPeriod[0], selPeriod[1]).add(1, 'days').format('yyyy-MM-DD');
    }


  };

  @action
  setReviewSync = async (type) => {
    let _this = this;
    if(! await this.checkPaidUser(_this.store)) return false;
    _this.isLoading = true;

    let data = {
      store_id: _this.store._id,
      shopNo: this.teamUser.selShopNo || 1,
      getType: type || 'new',
      // data.params 는 아래에서 설정
    };

    const getMonthlyRanges = (start, end) => {
      let ranges = [];
      end = moment(end).add(1, 'days')
      let current = moment(start);
      const last = moment(end);

      if ( last.diff(current, 'months', true) <= 2 ) {
        ranges =  [{
          startDate: current.format('YYYY-MM-DD'),
          endDate:   last.format('YYYY-MM-DD'),
        }];
      }
      else {
        while (current.isBefore(last) || current.isSame(last, 'day')) {
          // 2개월 뒤 하루 전을 계산
          let monthEnd = current.clone().add(2, 'months').subtract(1, 'day');
          // 범위를 벗어나면 end 값으로 고정
          if (monthEnd.isAfter(last)) {
            monthEnd = last.clone();
          }

          ranges.push({
            startDate: current.format('YYYY-MM-DD'),
            endDate:   monthEnd.format('YYYY-MM-DD'),
          });

          // 다음 구간 시작은 이전 구간 종료 다음 날
          current = monthEnd.clone().add(1, 'day');
        }
      }

      return ranges;


    };

    if (type === 'period') {
      // 기간 유효성 검사
      if (!isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
        alert('최대 ' + this.serarchPeriod[2] + '단위로 선택해 주세요.');
        _this.isLoading = false;
        return false;
      }
      // 월 단위로 분할해서 순차 호출
      const ranges = getMonthlyRanges(this.syncReviewValue.startDate, this.syncReviewValue.endDate);
      for (const params of ranges) {
        data.params = params;

        // 콜백 기반 API를 Promise로 감싸서 await 가능하게
        const res = await new Promise(resolve => {
          _this.props.setReviewSync(data, resolve);
        });
        if (res && res.data) {
          toast(
              moment(res.data.startDate).format('YYYY-MM-DD')
              + ' ~ '
              + moment(res.data.endDate).format('YYYY-MM-DD')
              + ' 기간의 리뷰가 '
              + res.data.insertReviewCount
              + '개 업데이트 되었습니다.'
          );
        }
      }
    } else {
      // 기존 단일 호출 로직
      data.params = this.syncReviewValue;
      await new Promise(resolve => {
        _this.props.setReviewSync(data, resolve);
      }).then(res => {
        if (res && res.data) {
          toast(
              moment(res.data.startDate).format('YYYY-MM-DD')
              + ' ~ '
              + moment(res.data.endDate).format('YYYY-MM-DD')
              + ' 기간의 리뷰가 '
              + res.data.insertReviewCount
              + '개 업데이트 되었습니다.'
          );
        }
      });
    }
    _this.isLoading = false;
    // ─── 수정된 부분 끝 ───
  };


  // setReviewSync = async (type) => {
  //   let _this = this;
  //   //let confimRes = window.confirm("기존 온리플의 리뷰는 모두 삭제되고 카페24 리뷰로 대체 됩니다. 진행하시겠습니까?");
  //   if(! await this.checkPaidUser(_this.store)) return false;
  //   _this.isLoading = true;
  //   let data = {
  //     store_id: _this.store._id,
  //     shopNo: _this.teamUser.selShopNo ? _this.teamUser.selShopNo : 1,
  //     getType: type ? type : 'new',
  //
  //   }
  //   if(type === 'period') {
  //     if(isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, _this.serarchPeriod)) {
  //       data.params = this.syncReviewValue;
  //     }
  //     else {
  //       alert('최대 ' + this.serarchPeriod[2]  + '단위로 선택해 주세요.');
  //       _this.isLoading = false;
  //       return false;
  //     }
  //     data.params = this.syncReviewValue;
  //   }
  //
  //
  //   _this.props.setReviewSync(data, function(res) {
  //     if(res && res.data) {
  //       toast(moment(res.data.startDate).format('YYYY-MM-DD') + ' ~ ' + moment(res.data.endDate).format('YYYY-MM-DD') + ' 기간의 리뷰가 ' +  res.data.insertReviewCount + '개 업데이트 되었습니다.');
  //       if(res.data.insertReviewCount > 0) {
  //         _this.getReviewList();
  //       }
  //     }
  //     _this.isLoading = false;
  //   });
  //
  // };



  @action
  modalToggle = function(target, data) {
    this.modals[target] = !this.modals[target];
    if(!target) {
      for( var i in this.modals) {
        this.modals[i] = false;
      }
    }

    if(target === 'isCafeSettingModal') {
      // if(!this.isUse) {
      //   alert('사용권한이 없습니다.');
      //   return false;
      // }
      if(this.skins.length === 0) {
        this.getApplySkins(true);
      }
    }

    if(data) {
      if(target === 'isCafeSettingModal' && data) {
        this.modals.widgetData.product = data;
      }
      else {
        this.modals.data = data;
      }
    }

    if(target === 'isSyncReview') {
      this.selectPeriod(1, 'days');
    }

  };



  onChangeSyncReviewValue = async (event, obj) => {
    const { name, value, type } = event.target;
    let newValue;
    if(type === 'checkbox') {
      if(value) {
        newValue = !JSON.parse(value);
      }
      else {
        newValue = true;
      }
    }
    else {
      newValue = value;
    }

    if(obj) {
      obj[name] = newValue;

      if(name === 'all') {
        for(let key in obj) {
          obj[key] = newValue;
        }
      }
      else {
        let isAll = false;
        if(newValue) {
          isAll = true;
          for(let key in obj) {
            if(!obj[key] && key !== 'all') {
              isAll = false;
              break;
            }
          }
        }
        obj['all'] = isAll;
      }
    }
    else {
      this.syncReviewValue[name] = newValue;
    }

  };


  onChangeCalendarValueForRS = async (date, dateType) => {
    this.isShowCalendarForRS = {
      startDate: false,
      endDate: false,
    };
    this.syncReviewValue[dateType] = moment(date).format('yyyy-MM-DD');
    // if((this.syncReviewValue.startDate || this.syncReviewValue.endDate) && !isOverPeriod(this.syncReviewValue.startDate, this.syncReviewValue.endDate, this.serarchPeriod)) {
    //   alert('최대 ' + this.serarchPeriod[2]  + '로 선택해 주세요.');
    //
    // }
  }


  updateLimits = async (event) => {
    let _this = this;

    this.props.updateDoc('updateLimits', this.reviewWrightLimit, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {
        _this.newFilterWord = { block: '', alter: ''};
      }
    });

  };

  addPhrase = async (event, target) => {
    if(target === 'mainPhase') {
      this.basicSettings.mainPhase.push(this.newMainPhase);
      this.newMainPhase = '';
    }
    else if(target === 'subPhase') {
      this.basicSettings.subPhase.push(this.newSubPhase);
      this.newSubPhase = '';
    }
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {

      }
    });
  }

  removePhrase = async (event, target, i) => {
    if(target === 'mainPhase') {
      this.basicSettings.mainPhase.splice(i, 1);
    }
    else if(target === 'subPhase') {
      this.basicSettings.subPhase.splice(i, 1);
    }
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        alert(res.errors[0].message);
      }
      else {

      }
    });
  }

  // saveAutoReplyConfig = async () => {
  //   if(this.basicSettings.writer === '') {
  //     toast('댓글 작성에 필요한 댓글 작성자 이름을 입력해 주세요.');
  //     return;
  //   }
  //   else if(this.basicSettings.password === '') {
  //     alert('댓글 작성에 필요한 비밀번호를 입력해 주세요.');
  //     return;
  //   }
  //
  //   const res = await this.props.updateDoc('updateBasicSettings', this.basicSettings);
  //   if (res.errors && res.errors.length > 0) {
  //     toast(res.errors[0].message);
  //   } else {
  //     toast('저장 되었습니다.');
  //   }
  // };

  updateBasicSetting = async (event, updateKeys) => {
    if(this.basicSettings.writer === '') {
      toast('댓글 작성에 필요한 댓글 작성자 이름을 입력해 주세요.');
      return;
    }
    else if(this.basicSettings.password === '') {
      alert('댓글 작성에 필요한 비밀번호를 입력해 주세요.');
      return;
    }

    let _this = this;
    this.props.updateDoc('updateBasicSettings', this.basicSettings, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast('저장 되었습니다.');
        _this.basicSettingsDirty = false;
      }
    });
  }

  updateMetaWidget = (filter) => {
    let _this = this;
    let updateParams = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1
    };
    for (let i in filter) updateParams[filter[i]] = this.metaWidget[filter[i]];
    this.props.updateDoc('updateMetaWidget', updateParams, function(res) {
      if (res.errors && res.errors.length > 0) toast(res.errors[0].message);
      else _this.metaWidgetDirty = false;
    });
  };

  saveAllSettings = (e) => {
    if (this.basicSettingsDirty) this.updateBasicSetting(e);
    if (this.metaWidgetDirty) {
      this.updateMetaWidget(['productMetaType', 'productMetaTypeAlign', 'productListConfig', 'reviewRatingCount', 'reviewRatingCountConfig']);
    }
  };

  revertAllSettings = () => {
    this.basicSettingsDirty = false;
    this.metaWidgetDirty = false;
    this.init();
  };

  updateFilter = async (event) => {
    let _this = this;
    if(!_this.newFilterWord.block) {
      alert("차단어를 입력해 주세요");
      return false;
    }
    if(!_this.newFilterWord.alter) {
      alert("대체어를 입력해 주세요");
      return false;
    }
    this.filterWords.push(_this.newFilterWord);
    this.reviewFiltering.filterWords = this.filterWords;

    this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        _this.newFilterWord = { block: '', alter: ''};
      }

    });
  };

  delFilter = async (del_index, event) => {
    this.filterWords.splice(del_index, 1);

    this.reviewFiltering.filterWords = this.filterWords;

    this.props.updateDoc('updateFilter', this.reviewFiltering, function(res) {
      if(res.errors && res.errors.length > 0) {
        toast(res.errors[0].message);
      }
      else {
        toast('삭제 되었습니다.');
      }

    });
  };


  onDragStart = async (del_index, event) => {

  };

  onDragEnd = async (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    this.basicSettings.mainPhase = reorder(
      this.basicSettings.mainPhase,
      result.source.index,
      result.destination.index
    );
  }


  onChangeColor =  async (name, color, targetObj) => {
    targetObj[name] = color.hex;
    if (targetObj === this.basicSettings) this.basicSettingsDirty = true;
    // this.showColorModalFn();
  };

  showColorModalFn =  async (targetModal, event) => {
    if(targetModal) {
      if(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        this.colorPickerPos = { top: rect.bottom + 4, left: rect.left };
      }
      this[targetModal] = true;
    }
    else {
      this.isShowMColor_1 = false;
    }
  };

  checkPaidUser = async (store) => {

    if(!store.isPaidUser) {
      alert("유료 사용자만 이용이 가능합니다.");

    }
    return store.isPaidUser;
  }


  render() {

    // const reorder = (list, startIndex, endIndex) => {
    //   const result = Array.from(list);
    //   const [removed] = result.splice(startIndex, 1);
    //   result.splice(endIndex, 0, removed);
    //
    //   return result;
    // };
    //
    // const grid = 8;

    const getItemStyle = (isDragging, draggableStyle) => ({
      userSelect: "none",
      background: isDragging ? "lightgreen" : "",
      ...draggableStyle
    });

    const getListStyle = isDraggingOver => ({
      background: isDraggingOver ? "lightblue" : "",
    });

    function skinLanguageCodeKR (code) {
      switch (code) {
        case 'ko_KR':
          return '국문';
        case 'en_US':
          return '영문';
        case 'zh_CN':
          return '중문(간체)';
        case 'zh_TW':
          return '중문(번체)';
        case 'ja_JP':
          return '일문';
        case 'pt_PT':
          return '포르투갈어';
        case 'es_ES':
          return '스페인어';
        case 'vi_VN':
          return '베트남어';
        default:
          return code;

      }
    }

    return (
      <>
      <div className="main-content">
          <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16}}>
            <PageTitle />
            <HelpButton tourKey="reviewWriteConfig" />
          </div>

          {( this.isLogin && this.teamUser.emailId ) ?
            <div className="widget-box write-post-box">

              {/* === 카페24 자료실 용량 안내문 === */}
              <div className="rwc-board-capacity-notice">
                <div className="rwc-board-capacity-notice__icon">
                  <FeatherIcon icon="alert-circle" size="18"/>
                </div>
                <div className="rwc-board-capacity-notice__text">
                  카페24 자료실 게시판 용량 현황에서 사용가능 공간이 있어야 카페24에 리뷰가 작성이 됩니다.
                </div>
                <Button size="sm" theme="light" className="rwc-board-capacity-notice__btn"
                        onClick={() => this.modals.isBoardCapacityGuide = true}>
                  <FeatherIcon icon="help-circle" size="14"/>
                  <span style={{marginLeft: 4}}>자세히 보기</span>
                </Button>
              </div>

              {/* 기본 리뷰위젯(상세페이지) — 페이지 상단 배치 (필수설정) */}
              <div className={`wbp-accordion ${this.openRwcSection === 'detailWidget' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('detailWidget')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="layout" size="16"/>
                    <span><span style={{color: '#dc3545', fontWeight: 'bold', marginRight: 4}}>(필수설정)</span>기본 리뷰위젯(상세페이지)</span>
                    {this.renderSectionHelp('detailWidget')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'detailWidget' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'detailWidget' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <div className="section-tit" style={{display: 'none'}}>
                    <h3><FeatherIcon icon="layout" size="18" className="section-icon"/> 기본 리뷰위젯(상세페이지)</h3>
                    <p className="section-desc">상세 페이지에 표시되는 기본 리뷰 위젯의 스타일을 설정합니다.</p>
                  </div>
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>리뷰 리스트 사용</th>
                      <td>
                        <FormCheckbox toggle small checked={!this.basicSettings.isNoDisProductReview}
                                      onChange={event => this.onChangeChecked(event, this.basicSettings, ['isNoDisProductReview'])}>
                          {this.basicSettings.isNoDisProductReview ? '미사용' : '사용'}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr data-tour="rwc-dw-count">
                      <th>리뷰 리스트 표시 갯수</th>
                      <td>
                        <FormSelect value={this.basicSettings.perListCount} name="perListCount"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="0">미노출</option>
                          <option value="3">3</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                        </FormSelect>
                      </td>
                    </tr>
                    <tr data-tour="rwc-dw-sort">
                      <th>리스트 정렬</th>
                      <td>
                        <FormSelect value={this.basicSettings.listSortType} name="listSortType"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="newst">최신순</option>
                          <option value="rcm">추천순(포토리뷰순)</option>
                          <option value="grade">평점순</option>
                        </FormSelect>
                      </td>
                    </tr>
                    <tr data-tour="rwc-dw-version">
                      <th>리뷰상세 보기 버전</th>
                      <td>
                        <FormSelect value={this.basicSettings.reviewDetailV} name="reviewDetailV"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="v1">V1</option>
                          <option value="v1_total">V1 토탈(풀스크린)</option>
                          <option value="v2" disabled={true}>V2</option>
                        </FormSelect>
                      </td>
                    </tr>
                    <tr>
                      <th>부모 클래스/ID</th>
                      <td>
                        <FormInput
                            name="parentSelector"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.parentSelector) || ''}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.parentSelector = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder=".class-name 또는 #element-id"
                        />
                        <p className="text-muted mt-1">예: .review-container, #review-wrap</p>
                      </td>
                    </tr>
                    <tr>
                      <th>부모 클래스/ID(모바일)</th>
                      <td>
                        <FormInput
                            name="parentSelectorMobile"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.parentSelectorMobile) || ''}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.parentSelectorMobile = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder=".class-name 또는 #element-id"
                        />
                        <p className="text-muted mt-1">예: .review-container, #review-wrap</p>
                      </td>
                    </tr>
                    <tr>
                      <th>위젯 삽입 위치</th>
                      <td>
                        <FormSelect
                            name="insertPosition"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.insertPosition) || 'append'}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.insertPosition = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                        >
                          <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                          <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                          <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                          <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                          <option value="html">지정 요소의 내용을 대체</option>
                        </FormSelect>
                        <p className="text-muted mt-1">부모 클래스/ID로 지정한 요소를 기준으로 위젯이 삽입될 위치를 선택합니다.</p>
                      </td>
                    </tr>
                    <tr>
                      <th>위젯 최대너비</th>
                      <td>
                        <FormInput
                            name="maxWidth"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.maxWidth) || '100%'}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.maxWidth = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder="100%, 1200px, auto"
                        />
                        <p className="text-muted mt-1">예: 100%, 1200px, auto</p>
                      </td>
                    </tr>
                    <tr>
                      <th>상단여백</th>
                      <td>
                        <FormInput
                            name="marginTop"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.marginTop) || '0px'}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.marginTop = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder="0px, 30px"
                        />
                        <p className="text-muted mt-1">예: 0px, 30px</p>
                      </td>
                    </tr>
                    <tr>
                      <th>하단여백</th>
                      <td>
                        <FormInput
                            name="marginBottom"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.marginBottom) || '0px'}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.marginBottom = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder="0px, 30px"
                        />
                        <p className="text-muted mt-1">예: 0px, 30px</p>
                      </td>
                    </tr>
                    <tr>
                      <th>좌우여백</th>
                      <td>
                        <FormInput
                            name="lrPadding"
                            value={(this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.lrPadding) || '0px'}
                            onChange={event => {
                              if (!this.basicSettings.productReviewWidgetConfig) {
                                this.basicSettings.productReviewWidgetConfig = {};
                              }
                              this.basicSettings.productReviewWidgetConfig.lrPadding = event.target.value;
                              this.basicSettingsDirty = true;
                            }}
                            placeholder="0px, 20px"
                        />
                        <p className="text-muted mt-1">예: 0px, 20px</p>
                      </td>
                    </tr>
                    <tr>
                      <th>고정리뷰 페이징에 포함</th>
                      <td>
                        <FormCheckbox toggle small checked={this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.isPinnedReviewInPaging}
                                      onChange={event => {
                                        if (!this.basicSettings.productReviewWidgetConfig) {
                                          this.basicSettings.productReviewWidgetConfig = {};
                                        }
                                        this.basicSettings.productReviewWidgetConfig.isPinnedReviewInPaging = !this.basicSettings.productReviewWidgetConfig.isPinnedReviewInPaging;
                                        this.basicSettingsDirty = true;
                                      }}>
                          {this.basicSettings.productReviewWidgetConfig && this.basicSettings.productReviewWidgetConfig.isPinnedReviewInPaging ? '포함' : '미포함'}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        AI 키워드 인사이트
                        <span className="wbp-new-chip" style={{marginLeft: 6}}>NEW</span>
                      </th>
                      <td>
                        <FormCheckbox toggle small
                                      checked={!!(this.basicSettings.aiKeywordsConfig && this.basicSettings.aiKeywordsConfig.enabled)}
                                      onChange={() => {
                                        if (!this.basicSettings.aiKeywordsConfig) this.basicSettings.aiKeywordsConfig = {};
                                        this.basicSettings.aiKeywordsConfig.enabled = !this.basicSettings.aiKeywordsConfig.enabled;
                                        this.basicSettingsDirty = true;
                                      }}>
                          {(this.basicSettings.aiKeywordsConfig && this.basicSettings.aiKeywordsConfig.enabled) ? '사용중' : '미사용중'}
                        </FormCheckbox>
                        <p className="text-muted" style={{fontSize: 12, marginTop: 6, marginBottom: 0}}>
                          AI가 분석한 키워드를 상품 상세 리뷰 위젯 상단에 노출합니다. 키워드 클릭 시 해당 리뷰만 인라인으로 필터됩니다. (전체 리뷰 20건 이상부터 자동 생성)
                        </p>

                        {(this.basicSettings.aiKeywordsConfig && this.basicSettings.aiKeywordsConfig.enabled) && (
                          <div style={{marginTop: 12, padding: 12, border: '1px solid #E5E7EB', borderRadius: 8, background: '#FAFBFD'}}>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'center'}}>
                              <div>
                                <label style={{fontSize: 12, color: '#6B7280', marginRight: 8}}>표시 키워드 수</label>
                                <FormSelect value={this.basicSettings.aiKeywordsConfig.displayCount || 7}
                                            style={{display: 'inline-block', width: 100}}
                                            onChange={e => {
                                              this.basicSettings.aiKeywordsConfig.displayCount = parseInt(e.target.value, 10) || 7;
                                              this.basicSettingsDirty = true;
                                            }}>
                                  <option value="5">5개</option>
                                  <option value="7">7개</option>
                                  <option value="10">10개</option>
                                </FormSelect>
                              </div>

                              <div>
                                <label style={{fontSize: 12, color: '#6B7280', marginRight: 8}}>배경 테마</label>
                                <FormSelect value={this.basicSettings.aiKeywordsConfig.themeBg || 'theme-0'}
                                            style={{display: 'inline-block', width: 160}}
                                            onChange={e => {
                                              this.basicSettings.aiKeywordsConfig.themeBg = e.target.value;
                                              this.basicSettingsDirty = true;
                                            }}>
                                  <option value="theme-0">기본 (퍼플)</option>
                                  <option value="theme-1">선셋 오렌지</option>
                                  <option value="theme-2">오로라 그린</option>
                                  <option value="theme-3">네온 블루</option>
                                  <option value="theme-4">코랄 핑크</option>
                                  <option value="theme-5">모노 블랙</option>
                                </FormSelect>
                              </div>
                            </div>

                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 10}}>
                              <FormCheckbox toggle small
                                            checked={!!this.basicSettings.aiKeywordsConfig.showSummary}
                                            onChange={() => {
                                              this.basicSettings.aiKeywordsConfig.showSummary = !this.basicSettings.aiKeywordsConfig.showSummary;
                                              this.basicSettingsDirty = true;
                                            }}>
                                AI 한줄 요약 카드 {this.basicSettings.aiKeywordsConfig.showSummary ? '노출' : '미노출'}
                              </FormCheckbox>

                              <FormCheckbox toggle small
                                            checked={!!this.basicSettings.aiKeywordsConfig.enableFilter}
                                            onChange={() => {
                                              this.basicSettings.aiKeywordsConfig.enableFilter = !this.basicSettings.aiKeywordsConfig.enableFilter;
                                              this.basicSettingsDirty = true;
                                            }}>
                                키워드 클릭 시 리뷰 인라인 필터 {this.basicSettings.aiKeywordsConfig.enableFilter ? '사용' : '미사용'}
                              </FormCheckbox>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
                </div>
                </div>
                </div>
              </div>

              {/* === 카페24 설정 === */}
              <div className={`wbp-accordion ${this.openRwcSection === 'cafe24' ? 'is-open' : ''}`} style={{marginTop: 16}} id="basicWriteSettings">
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('cafe24')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="shopping-bag" size="16"/>
                    <span><span style={{color: '#dc3545', fontWeight: 'bold', marginRight: 4}}>(필수설정)</span>카페24 설정</span>
                    {this.renderSectionHelp('cafe24')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'cafe24' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'cafe24' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                    </colgroup>
                    <tbody>
                    <tr>
                      <th>도메인 정보</th>
                      <td>
                        <InputGroup>
                          <FormInput value={this.store.domain || ''}
                                     readOnly
                                     style={{background: '#F9FAFB', cursor: 'not-allowed'}}
                                     placeholder={this.store.platformId ? `${this.store.platformId}.cafe24.com` : '연동 후 자동 표시'} />
                          <InputGroupAddon type="append" className="addon-text-notice">쇼핑몰 도메인</InputGroupAddon>
                        </InputGroup>
                        <p className="text-right mt-1 mr-3" style={{fontSize: 12, color: '#6B7280'}}>
                          도메인 변경은 <a href="/companyInfo" className="text-info">회사 정보 관리</a> 에서 가능합니다.
                          {this.store.domain && (
                            <>
                              {' · '}
                              <a className="text-info"
                                 href={(this.store.domain.indexOf('http') === 0 ? '' : 'https://') + this.store.domain}
                                 target="_blank" rel="noopener noreferrer">쇼핑몰 바로가기</a>
                            </>
                          )}
                        </p>
                      </td>
                    </tr>
                    <tr data-tour="rwc-cafe24-board">
                      <th>* 리뷰 게시판 ID</th>
                      <td>
                        <InputGroup>
                          <FormInput value={this.store.cafe24UseReviewBoardNo}
                                     name="cafe24UseReviewBoardNo" className="text-center"
                                     onChange={event => this.onChangeInputs(event, this.store)}
                                     type="number"
                                     placeholder="초기 셋팅 id는 4입니다."/>
                          <InputGroupAddon type="append" className="addon-text-notice">초기 셋팅 id는 4입니다.</InputGroupAddon>
                        </InputGroup>
                        <p className="text-right mt-1 mr-3">
                          <a className="text-info"
                             href={"https://" + this.store.platformId + ".cafe24.com/admin/php/shop1/b/board_admin_l.php"}
                             target="_blank" rel="noopener noreferrer">카페24 > 게시판 > 게시판관리</a> 에서 확인
                        </p>
                      </td>
                    </tr>
                    <tr data-tour="rwc-cafe24-url">
                      <th>* 상품 상세 URL 형식</th>
                      <td className="text-left">
                        <FormRadio
                            name="productDetailUrlEasy"
                            checked={!this.basicSettings.productDetailUrlType || this.basicSettings.productDetailUrlType === 'easy'}
                            onChange={() => { this.basicSettings.productDetailUrlType = 'easy'; this.basicSettingsDirty = true; }}>
                          쉬운 URL 형식 <span className="text-muted">(기본값, 예: <code>/product/상품명/상품번호/category/카테고리코드</code>)</span>
                        </FormRadio>
                        <FormRadio
                            name="productDetailUrlBasic"
                            checked={this.basicSettings.productDetailUrlType === 'basic'}
                            onChange={() => { this.basicSettings.productDetailUrlType = 'basic'; this.basicSettingsDirty = true; }}>
                          기본 URL 형식 <span className="text-muted">(예: <code>/product/detail.html?product_no=상품번호</code>)</span>
                        </FormRadio>
                        <p className="mt-1">쇼핑몰 설정에 따라 상품 상세 페이지로 이동하는 URL 형식을 선택합니다.</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </div>
                </div>
              </div>

              {/* === 작성 === */}
              <div className={`wbp-accordion ${this.openRwcSection === 'write' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('write')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="edit-3" size="16"/>
                    <span><span style={{color: '#dc3545', fontWeight: 'bold', marginRight: 4}}>(필수설정)</span>작성</span>
                    {this.renderSectionHelp('write')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'write' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'write' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                      <col/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-write-period">
                      <th>작성 가능 시점 및 기간</th>
                      <td>
                        <FormSelect value={this.basicSettings.writeEnabledState} name="writeEnabledState"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="1">배송완료 후</option>
                          <option value="2">주문 완료 후(결제완료)</option>
                          <option value="3">주문 완료 후(결제미완료 포함)</option>
                        </FormSelect>
                      </td>
                      <td>
                        <InputGroup>
                          <FormInput value={this.basicSettings.writeEnabledDate} name="writeEnabledDate"
                                     className="text-center" type="number" max="60"
                                     onChange={event => this.onChangeInputs(event, this.basicSettings)}
                                     onBlur={event => this.nullCheck(event, this.basicSettings, 50)}
                                     placeholder="작성 시점에서 몇 일까지 작성이 가능한지 입력해 주세요."/>
                          <InputGroupAddon type="append" className="addon-text-notice">일 까지 작성 가능(최대
                            60일)</InputGroupAddon>
                        </InputGroup>
                      </td>
                    </tr>
                    <tr data-tour="rwc-write-chars">
                      <th>글자수 제한</th>
                      <td>
                        <Row>
                          <Col>
                            <InputGroup>
                              <FormInput value={this.basicSettings.minChars} name="minChars" className="text-center"
                                         onChange={event => this.onChangeInputs(event, this.basicSettings)}
                                         placeholder="최소 입력 글자수를 입력해 주세요."/>
                              <InputGroupAddon type="append" className="addon-text-notice">글자 이상</InputGroupAddon>
                            </InputGroup>
                          </Col>
                          <Col>
                            <InputGroup>
                              <FormInput value={this.basicSettings.maxChars} name="maxChars" className="text-center"
                                         onChange={event => this.onChangeInputs(event, this.basicSettings)}
                                         placeholder="최대 입력 글자수를 입력해 주세요."/>
                              <InputGroupAddon type="append" className="addon-text-notice">글자 이하</InputGroupAddon>
                            </InputGroup>
                          </Col>
                        </Row>
                      </td>
                      <td className="text-left">
                        <FormCheckbox toggle small checked={this.basicSettings.isDeliveryRating}
                                      onChange={event => this.onChangeChecked(event, this.basicSettings, ['isDeliveryRating'])}>
                          배송 평가 {this.basicSettings.isDeliveryRating ? '사용중' : '미사용중'}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr data-tour="rwc-write-pending">
                      <th>리뷰 별점에 따른 대기 처리</th>
                      <td className="text-left" colSpan={2}>
                        <FormSelect value={this.basicSettings.pendingRatingThreshold || ''}
                                    name="pendingRatingThreshold"
                                    onChange={event => this.onChangeInputs(event, this.basicSettings)}
                                    style={{maxWidth: 240}}>
                          <option value="">미사용</option>
                          <option value="all">전부 (모든 리뷰 대기)</option>
                          <option value="5">5점 밑으로 (1~4점)</option>
                          <option value="4">4점 밑으로 (1~3점)</option>
                          <option value="3">3점 밑으로 (1~2점)</option>
                          <option value="2">2점 밑으로 (1점)</option>
                        </FormSelect>
                        <p className="text-muted mt-1">선택한 조건에 해당하는 리뷰는 즉시 노출되지 않고 <b>관리자 승인 대기 상태</b>로 저장됩니다. 관리자 검토 후 공개/비공개 처리할 수 있습니다.</p>
                      </td>
                    </tr>
                    <tr>
                      <th>리뷰 작성시 구매확정 처리</th>
                      <td className="text-left" colSpan={2}>
                        <FormCheckbox toggle small checked={this.basicSettings.isOrderConfirmOnReview}
                                      onChange={event => this.onChangeChecked(event, this.basicSettings, ['isOrderConfirmOnReview'])}>
                          {this.basicSettings.isOrderConfirmOnReview ? '사용중' : '미사용중'}
                        </FormCheckbox>
                        <p className="text-muted mt-1">리뷰 작성 시 해당 주문을 자동으로 구매확정 처리합니다.</p>
                      </td>
                    </tr>
                    <tr>
                      <th>비구매 리뷰 작성</th>
                      <td className="text-left" colSpan={2}>
                        <FormCheckbox toggle small checked={this.reviewWrightLimit.isUseNoPurchase}
                                      onChange={event => {
                                        this.reviewWrightLimit.isUseNoPurchase = !this.reviewWrightLimit.isUseNoPurchase;
                                        this.updateLimits();
                                      }}>
                          {this.reviewWrightLimit.isUseNoPurchase ? '사용중' : '미사용중'}
                        </FormCheckbox>
                        <p className="text-muted mt-1">비구매 고객이 이름, 전화번호, 구입경로를 입력하여 리뷰를 작성할 수 있습니다.</p>
                      </td>
                    </tr>
                    {this.reviewWrightLimit.isUseNoPurchase && (
                      <tr>
                        <th>리뷰 작성자 정보</th>
                        <td className="text-left" colSpan={2}>
                          <table className="table table-sm mb-2" style={{maxWidth: '600px'}}>
                            <thead>
                              <tr>
                                <th style={{width: '30%'}}>항목</th>
                                <th style={{width: '70%'}}>설정</th>
                              </tr>
                            </thead>
                            <tbody>
                              {[
                                {key: 'phone', label: '연락처'},
                                {key: 'email', label: '이메일'},
                                {key: 'purchaseChannel', label: '구입경로'}
                              ].map(field => (
                                <tr key={field.key}>
                                  <td>{field.label}</td>
                                  <td>
                                    <ButtonGroup size="sm">
                                      {[
                                        {value: 'required', label: '필수'},
                                        {value: 'optional', label: '선택'},
                                        {value: 'hidden', label: '미노출'}
                                      ].map(opt => (
                                        <Button
                                          key={opt.value}
                                          theme={this.reviewWrightLimit.noPurchaseFields[field.key] === opt.value ? 'primary' : 'light'}
                                          onClick={() => {
                                            this.reviewWrightLimit.noPurchaseFields[field.key] = opt.value;
                                            this.updateLimits();
                                          }}>
                                          {opt.label}
                                        </Button>
                                      ))}
                                    </ButtonGroup>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {this.reviewWrightLimit.noPurchaseFields.purchaseChannel !== 'hidden' && (
                            <div className="mt-3" style={{maxWidth: '600px'}}>
                              <h6 className="mb-2">구입경로 옵션</h6>
                              <ul className="list-group mb-2">
                                {(this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions || []).map((opt, idx) => (
                                  <li key={idx} className="list-group-item d-flex align-items-center" style={{padding: '6px 12px'}}>
                                    <FormInput
                                      size="sm"
                                      value={opt}
                                      onChange={event => {
                                        this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions[idx] = event.target.value;
                                      }}
                                      onBlur={() => this.updateLimits()}
                                      style={{flex: 1, marginRight: '8px'}}
                                    />
                                    <Button size="sm" theme="danger" outline
                                            onClick={() => {
                                              this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions.splice(idx, 1);
                                              this.updateLimits();
                                            }}>
                                      삭제
                                    </Button>
                                  </li>
                                ))}
                              </ul>
                              <div className="d-flex align-items-center">
                                <FormInput
                                  size="sm"
                                  placeholder="새 옵션 입력"
                                  value={this.newPurchaseChannelOption}
                                  onChange={event => { this.newPurchaseChannelOption = event.target.value; }}
                                  onKeyPress={event => {
                                    if(event.key === 'Enter') {
                                      let val = (this.newPurchaseChannelOption || '').trim();
                                      if(val) {
                                        if(!this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions) {
                                          this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions = [];
                                        }
                                        this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions.push(val);
                                        this.newPurchaseChannelOption = '';
                                        this.updateLimits();
                                      }
                                    }
                                  }}
                                  style={{flex: 1, marginRight: '8px'}}
                                />
                                <Button size="sm" theme="primary"
                                        onClick={() => {
                                          let val = (this.newPurchaseChannelOption || '').trim();
                                          if(val) {
                                            if(!this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions) {
                                              this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions = [];
                                            }
                                            this.reviewWrightLimit.noPurchaseFields.purchaseChannelOptions.push(val);
                                            this.newPurchaseChannelOption = '';
                                            this.updateLimits();
                                          }
                                        }}>
                                  추가
                                </Button>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    )}

                    <tr>
                      <th>작성 주요 안내문구</th>
                      <td colSpan={2}>
                        {this.basicSettings && this.basicSettings.mainPhase && this.basicSettings.mainPhase.length > 0 ?
                            <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                              <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <ul className='phase-list' ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}>
                                      {this.basicSettings.mainPhase.map((val, i) => (
                                          <Draggable key={i} draggableId={'item-' + i}
                                                     index={i}>{(provided, snapshot) => (
                                              <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                                  style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                {val}
                                                <FeatherIcon size="15" icon="x-circle" className="nd-icon"
                                                             onClick={e => this.removePhrase(e, 'mainPhase', i)}/>
                                              </li>)}
                                          </Draggable>
                                      ))}
                                      {provided.placeholder}
                                    </ul>
                                )}
                              </Droppable>
                            </DragDropContext>
                            :
                            null
                        }
                        <InputGroup>
                          <FormInput value={this.newMainPhase} name="newMainPhase" onChange={event => {
                            this.newMainPhase = event.target.value
                          }} placeholder="문구를 입력해 주세요."/>
                          <InputGroupAddon type="append"><Button theme="secondary"
                                                                 onClick={e => this.addPhrase(e, 'mainPhase')}>추가하기</Button></InputGroupAddon>
                        </InputGroup>
                      </td>
                    </tr>
                    <tr>
                      <th>작성 참고 안내문구</th>
                      <td colSpan={2}>
                        <ul className='phase-list'>
                          {this.basicSettings && this.basicSettings.subPhase && this.basicSettings.subPhase.length > 0 ?
                              this.basicSettings.subPhase.map((val, i) => (
                                  <li className='text-left' key={i} draggable>{val} <FeatherIcon size="15"
                                                                                                 icon="x-circle"
                                                                                                 className="nd-icon"
                                                                                                 onClick={e => this.removePhrase(e, 'subPhase', i)}/>
                                  </li>
                              ))
                              :
                              null
                          }
                        </ul>
                        <InputGroup>
                          <FormInput value={this.newSubPhase} name="newSubPhase" onChange={event => {
                            this.newSubPhase = event.target.value
                          }} placeholder="문구를 입력해 주세요."/>
                          <InputGroupAddon type="append"><Button theme="secondary"
                                                                 onClick={e => this.addPhrase(e, 'subPhase')}>추가하기</Button></InputGroupAddon>
                        </InputGroup>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </div>
                </div>
              </div>

              {/* === 디자인 === */}
              <div className={`wbp-accordion ${this.openRwcSection === 'design' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('design')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="droplet" size="16"/>
                    <span><span style={{color: '#dc3545', fontWeight: 'bold', marginRight: 4}}>(필수설정)</span>디자인</span>
                    {this.renderSectionHelp('design')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'design' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'design' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-design-font">
                      <th>기본 폰트 색상</th>
                      <td>
                        <div className="color-picker">
                          {this.isShowMColor_1 ? (
                            <div className="color-picker-selecter-wrap"
                                 style={{top: this.colorPickerPos.top, left: this.colorPickerPos.left}}
                                 onMouseLeave={event => this.isShowMColor_1 = false}>
                              <button className="color-picker-close-btn" onClick={() => this.isShowMColor_1 = false}>&times;</button>
                              <ChromePicker
                                name="defaultColor"
                                disableAlpha={true}
                                color={this.basicSettings.defaultColor}
                                onChangeComplete={(color) => {
                                  this.onChangeColor('defaultColor', color, this.basicSettings)
                                }}
                              />
                            </div>) : null}
                          <InputGroup>
                            <InputGroupAddon type="append">
                              <InputGroupText onClick={event => {
                                this.showColorModalFn('isShowMColor_1', event);
                              }} style={{backgroundColor: this.basicSettings.defaultColor}}>
                                <FeatherIcon icon="droplet" size="15" style={{color: this.basicSettings.defaultColor}}/>
                              </InputGroupText>
                            </InputGroupAddon>
                            <FormInput value={this.basicSettings.defaultColor} placeholder="색상값을 입력해 주세요."
                                       readOnly={true}
                                       onClick={event => {
                                         this.showColorModalFn('isShowMColor_1', event);
                                       }}/>
                          </InputGroup>
                        </div>
                      </td>
                    </tr>
                    <tr data-tour="rwc-design-theme">
                      <th>테마 폰트 색상</th>
                      <td>
                        <div className="color-picker">
                          {this.isShowMColor_2 ? (
                              <div className="color-picker-selecter-wrap"
                                   style={{top: this.colorPickerPos.top, left: this.colorPickerPos.left}}
                                   onMouseLeave={event => this.isShowMColor_2 = false}>
                                <button className="color-picker-close-btn" onClick={() => this.isShowMColor_2 = false}>&times;</button>
                                <ChromePicker
                                    name="themeColor"
                                    disableAlpha={true}
                                    color={this.basicSettings.themeColor}
                                    onChangeComplete={(color) => {
                                      this.onChangeColor('themeColor', color, this.basicSettings)
                                    }}
                                />
                              </div>) : null}
                          <InputGroup>
                            <InputGroupAddon type="append">
                              <InputGroupText onClick={event => {
                                this.showColorModalFn('isShowMColor_2', event);
                              }} style={{backgroundColor: this.basicSettings.themeColor}}>
                                <FeatherIcon icon="droplet" size="15" style={{color: this.basicSettings.themeColor}}/>
                              </InputGroupText>
                            </InputGroupAddon>
                            <FormInput value={this.basicSettings.themeColor} placeholder="색상값을 입력해 주세요."
                                       readOnly={true}
                                       onClick={event => {
                                         this.showColorModalFn('isShowMColor_2', event);
                                       }}/>
                          </InputGroup>
                        </div>
                      </td>
                    </tr>
                    <tr data-tour="rwc-design-star">
                      <th>별점 색상</th>
                      <td>
                        <div className="color-picker">
                          {this.isShowMColor_3 ? (
                              <div className="color-picker-selecter-wrap"
                                   style={{top: this.colorPickerPos.top, left: this.colorPickerPos.left}}
                                   onMouseLeave={event => this.isShowMColor_3 = false}>
                                <button className="color-picker-close-btn" onClick={() => this.isShowMColor_3 = false}>&times;</button>
                                <ChromePicker
                                    name="ratingMarkColor"
                                    disableAlpha={true}
                                    color={this.basicSettings.ratingMarkColor}
                                    onChangeComplete={(color) => {
                                      this.onChangeColor('ratingMarkColor', color, this.basicSettings)
                                    }}
                                />
                              </div>) : null}
                          <InputGroup>
                            <InputGroupAddon type="append">
                              <InputGroupText onClick={event => {
                                this.showColorModalFn('isShowMColor_3', event);
                              }} style={{backgroundColor: this.basicSettings.ratingMarkColor}}>
                                <FeatherIcon icon="droplet" size="15" style={{color: this.basicSettings.ratingMarkColor}}/>
                              </InputGroupText>
                            </InputGroupAddon>
                            <FormInput value={this.basicSettings.ratingMarkColor} placeholder="색상값을 입력해 주세요."
                                       readOnly={true}
                                       onClick={event => {
                                         this.showColorModalFn('isShowMColor_3', event);
                                       }}/>
                          </InputGroup>
                        </div>
                      </td>
                    </tr>
                    {/*<tr>
                      <th>보조 폰트 색상</th>
                      <td colSpan={2}>
                        <div className="color-picker">
                          {this.isShowMColor_1 ? (
                              <div className="color-picker-selecter-wrap"
                                   onMouseLeave={event => this.isShowMColor_1 = false}>
                                <ChromePicker
                                    name="color"
                                    disableAlpha={true}
                                    color={this.basicSettings.defaultColor}
                                    onChangeComplete={(color) => {
                                      this.onChangeColor('color', color, this.basicSettings)
                                    }}
                                />
                              </div>) : null}
                          <InputGroup>
                            <InputGroupAddon type="append">
                              <InputGroupText onClick={event => {
                                this.showColorModalFn('isShowMColor_1');
                              }} style={{backgroundColor: this.basicSettings.defaultColor}}>
                                <FeatherIcon icon="droplet" size="15" style={{color: this.basicSettings.defaultColor}}/>
                              </InputGroupText>
                            </InputGroupAddon>
                            <FormInput value={this.basicSettings.defaultColor} placeholder="색상값을 입력해 주세요."
                                       readOnly={true}
                                       onClick={event => {
                                         this.showColorModalFn('isShowMColor_1');
                                       }}/>
                          </InputGroup>
                        </div>
                      </td>
                    </tr>*/}
                    </tbody>
                  </table>
                  {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
                </div>
                </div>
                </div>
              </div>

              {/* === 리뷰 댓글(답글) 설정 === */}
              <div className={`wbp-accordion ${this.openRwcSection === 'comment' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('comment')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="message-square" size="16"/>
                    <span><span style={{color: '#dc3545', fontWeight: 'bold', marginRight: 4}}>(필수설정)</span>리뷰 댓글(답글) 설정</span>
                    {this.renderSectionHelp('comment')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'comment' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'comment' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-comment-writer">
                      <th>* 댓글 작성자 이름</th>
                      <td className="text-left">
                        <FormGroup>
                          <FormInput name="writer" autoComplete="off" placeholder="댓글 작성자 이름 입력"
                                     value={this.basicSettings.writer}
                                     onChange={event => this.onChangeInputs(event, this.basicSettings)} className="table-input-text search-input"/>
                        </FormGroup>
                      </td>
                    </tr>
                    <tr data-tour="rwc-comment-pw">
                      <th>* 댓글 관리자 비밀번호</th>
                      <td className="text-left">
                        <FormGroup>
                          {/* Chrome 의 "유출된 비밀번호 확인" 팝업 회피:
                              type="text" + CSS text-security 로 마스킹 유지 + 자동완성/패스워드매니저 비활성 */}
                          <FormInput name="cafe24CommentPwd"
                                     type="text"
                                     inputMode="text"
                                     autoComplete="off"
                                     spellCheck={false}
                                     data-1p-ignore="true"
                                     data-lpignore="true"
                                     data-form-type="other"
                                     placeholder="비밀번호 입력"
                                     value={this.basicSettings.password}
                                     onChange={event => {
                                       const e = { target: { name: 'password', value: event.target.value } };
                                       this.onChangeInputs(e, this.basicSettings);
                                     }}
                                     style={{
                                       WebkitTextSecurity: 'disc',
                                       MozTextSecurity: 'disc',
                                       textSecurity: 'disc'
                                     }}
                                     className="table-input-text search-input"/>
                        </FormGroup>
                        <p className="">비밀번호 (카페 24 리뷰 게시글 댓글 삭제 시 필요합니다.)</p>
                      </td>
                    </tr>
                    <tr data-tour="rwc-comment-config">
                      <th>* 리뷰 댓글 설정</th>
                      <td className="text-left">
                        <p className="mb-2">쇼핑몰 관리자 > 게시판 > 게시판 관리 > 해당 게시판 설정된 댓글 또는 답변을 선택해 주세요.</p>
                        <p className="mb-2">아래의 설정 수정 하시면 기존 답변에 대한 확인 및 점검이 필요합니다.</p>
                        <FormRadio
                            name="comment"
                            checked={!this.basicSettings.replyTyep || this.basicSettings.replyTyep === "comment"}
                            onChange={() => {
                              let cf = window.confirm("댓글기능으로 변경하시면 기존 답변기능으로 작성된 데이터가 댓글기능과 동일하게 적용 될 수 있게 운영자가 점검이 필요합니다. 변경하시겠습니까?");
                              if (cf) {
                                this.basicSettings.replyTyep = "comment";
                                this.basicSettingsDirty = true;
                              }
                            }}
                        >
                          댓글기능(추천)
                        </FormRadio>
                        <FormRadio
                            name="reply"
                            checked={this.basicSettings.replyTyep === "reply"}
                            onChange={() => {
                              let cf = window.confirm("답변기능으로 변경하시면 기존 댓글기능으로 작성된 데이터가 댓글기능과 동일하게 적용 될 수 있게 운영자가 점검이 필요합니다. 변경하시겠습니까?");
                              if (cf) {
                                this.basicSettings.replyTyep = "reply";
                                this.basicSettingsDirty = true;
                              }
                            }}
                        >
                          답변기능
                        </FormRadio>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </div>
                </div>
              </div>

              {/* 리뷰정보 노출 설정 */}
              <div className={`wbp-accordion ${this.openRwcSection === 'display' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('display')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="eye" size="16"/>
                    <span>리뷰정보 노출 설정</span>
                    {this.renderSectionHelp('display')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'display' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'display' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <div className="section-tit" style={{display: 'none'}}>
                    <h3><FeatherIcon icon="eye" size="18" className="section-icon"/> 리뷰정보 노출 설정</h3>
                    <p className="section-warning-notice">리뷰의 신뢰성을 유지하고 허위 리뷰로 오인되지 않도록 신중하게 설정해 주세요. 리뷰 노출 설정(이름 및 날짜 비공개 등)에 대한 책임은 전적으로 고객에게 있으며, 당사는 이에 대한 책임을 지지 않습니다.</p>
                  </div>
                  <div className="section-warning-notice" style={{marginBottom: 12}}>
                    리뷰의 신뢰성을 유지하고 허위 리뷰로 오인되지 않도록 신중하게 설정해 주세요. 리뷰 노출 설정(이름 및 날짜 비공개 등)에 대한 책임은 전적으로 고객에게 있으며, 당사는 이에 대한 책임을 지지 않습니다.
                  </div>
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                      <col width="170px"/>
                      <col/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-display-date">
                      <th>날짜 노출 여부</th>
                      <td>
                        <FormCheckbox toggle small checked={!this.basicSettings.isNoDisReviewDate}
                                      onChange={event => this.onChangeChecked(event, this.basicSettings, ['isNoDisReviewDate'])}>
                          {this.basicSettings.isNoDisReviewDate ? '미노출' : '노출'}
                        </FormCheckbox>
                      </td>
                      <th>작성자 노출 여부</th>
                      <td>
                        <FormCheckbox toggle small checked={!this.basicSettings.isNoDisReviewWriter}
                                      onChange={event => this.onChangeChecked(event, this.basicSettings, ['isNoDisReviewWriter'])}>
                          {this.basicSettings.isNoDisReviewWriter ? '미노출' : '노출'}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr data-tour="rwc-display-name">
                      <th>작성자 이름/ID 노출 선택</th>
                      <td>
                        <FormSelect value={this.basicSettings.writerDisType} name="writerDisType"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="1">이름</option>
                          <option value="2">ID</option>
                        </FormSelect>
                      </td>
                      <th>작성자명 노출 수</th>
                      <td>
                        <FormSelect value={this.basicSettings.writerDisTextCount} name="writerDisTextCount"
                                    onChange={event => {
                                      this.onChangeInputs(event, this.basicSettings)
                                    }}>
                          <option value="1">o*******</option>
                          <option value="2">on******</option>
                          <option value="3">onr*****</option>
                        </FormSelect>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
                </div>
                </div>
                </div>
              </div>

              {/* 상세페이지 리뷰 정보 표시 설정 — widgetByPage 의 별점 및 리뷰수 위젯에서 이전됨 */}
              <div className={`wbp-accordion ${this.openRwcSection === 'reviewRatingCount' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('reviewRatingCount')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="star" size="16"/>
                    <span>상세페이지 리뷰 정보 표시 설정</span>
                    {this.renderSectionHelp('reviewRatingCount')}
                    <span className={`wbp-status-chip ${this.metaWidget.reviewRatingCount === 'type_1' ? 'is-on' : 'is-off'}`}>
                      {this.metaWidget.reviewRatingCount === 'type_1' ? 'ON' : 'OFF'}
                    </span>
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'reviewRatingCount' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'reviewRatingCount' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
                  <table className="s-table">
                    <colgroup><col width="200px"/><col /></colgroup>
                    <tbody>
                    <tr data-tour="rwc-rrc-main">
                      <th>별점 및 리뷰수</th>
                      <td className="text-left">
                        <FormCheckbox toggle small
                          checked={this.metaWidget.reviewRatingCount === "type_1"}
                          onChange={() => {
                            this.metaWidget.reviewRatingCount = this.metaWidget.reviewRatingCount === 'type_1' ? 'no' : 'type_1';
                            this.metaWidgetDirty = true;
                          }}>
                          {this.metaWidget.reviewRatingCount === 'type_1' ? '사용함' : '사용안함'}
                        </FormCheckbox>
                      </td>
                    </tr>
                    <tr>
                      <th>부모 클래스/ID</th>
                      <td className="text-left">
                        <FormInput name="parentSelector"
                                   value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.parentSelector) || ''}
                                   onChange={this.onChangeReviewRatingCountConfig}
                                   placeholder=".class-name 또는 #element-id"
                                   style={{maxWidth: 420}} />
                        <p style={{marginTop: 5, marginBottom: 0, fontSize: 12, color: '#6B7280'}}>예: <code>.review-container</code>, <code>#review-wrap</code></p>
                      </td>
                    </tr>
                    <tr>
                      <th>위젯 삽입 위치</th>
                      <td className="text-left">
                        <FormSelect name="insertPosition"
                                    value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.insertPosition) || 'append'}
                                    onChange={this.onChangeReviewRatingCountConfig}
                                    style={{maxWidth: 320}}>
                          <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                          <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                          <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                          <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                          <option value="html">지정 요소의 내용을 대체</option>
                        </FormSelect>
                      </td>
                    </tr>
                    <tr>
                      <th>위젯 최대너비</th>
                      <td className="text-left">
                        <FormInput name="maxWidth"
                                   value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.maxWidth) || ''}
                                   onChange={this.onChangeReviewRatingCountConfig}
                                   placeholder="예: 100%, 1200px, auto"
                                   style={{maxWidth: 220}} />
                      </td>
                    </tr>
                    <tr data-tour="rwc-rrc-margin">
                      <th>여백 (상단/하단/좌우)</th>
                      <td className="text-left">
                        <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                          <FormInput name="marginTop"
                                     value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.marginTop) || ''}
                                     onChange={this.onChangeReviewRatingCountConfig}
                                     placeholder="상단"
                                     style={{width: 120}} />
                          <FormInput name="marginBottom"
                                     value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.marginBottom) || ''}
                                     onChange={this.onChangeReviewRatingCountConfig}
                                     placeholder="하단"
                                     style={{width: 120}} />
                          <FormInput name="lrPadding"
                                     value={(this.metaWidget.reviewRatingCountConfig && this.metaWidget.reviewRatingCountConfig.lrPadding) || ''}
                                     onChange={this.onChangeReviewRatingCountConfig}
                                     placeholder="좌우"
                                     style={{width: 120}} />
                          <span style={{fontSize: 12, color: '#9CA3AF'}}>예: 20px, 1rem</span>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </div>

              {/* 제품 리스트(카테고리) 페이지 설정 — widgetByPage에서 이전됨 */}
              <div className={`wbp-accordion ${this.openRwcSection === 'productList' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('productList')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="list" size="16"/>
                    <span>제품(리스트) 리뷰 정보 표시 설정</span>
                    {this.renderSectionHelp('productList')}
                    <span className={`wbp-status-chip ${this.metaWidget.productMetaType && this.metaWidget.productMetaType !== 'no' ? 'is-on' : 'is-off'}`}>
                      {this.metaWidget.productMetaType && this.metaWidget.productMetaType !== 'no' ? 'ON' : 'OFF'}
                    </span>
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'productList' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'productList' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: '4px 4px 12px'}}>
                  <table className="s-table">
                    <colgroup>
                      <col width="200px"/><col width=""/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-pl-show">
                      <th>리뷰 수/별점 노출</th>
                      <td className="text-left">
                        <div className="mw-page-check-list">
                          {[
                            {key: 'no', label: '사용안함', icon: 'x-circle'},
                            {key: 'both', label: '리뷰 수 + 별점', icon: 'star'},
                            {key: 'count', label: '리뷰 수', icon: 'hash'},
                            {key: 'score', label: '별점', icon: 'star'}
                          ].map(o => {
                            const cur = this.metaWidget.productMetaType || 'no';
                            const active = cur === o.key;
                            return (
                              <label key={o.key} className={`mw-page-check ${active ? 'is-checked' : ''}`}
                                     onClick={() => this.onChangeMetaInputs({target:{name:'productMetaType', value: o.key}}, this.metaWidget)}>
                                <FeatherIcon icon={o.icon} size="16"/>
                                <span>{o.label}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr data-tour="rwc-pl-pos">
                      <th>정렬 위치</th>
                      <td className="text-left">
                        <div className="mw-page-check-list">
                          {[
                            {key: 'no', label: '미설정(스킨디자인)', icon: 'layout'},
                            {key: 'left', label: '왼쪽 정렬', icon: 'align-left'},
                            {key: 'center', label: '가운데 정렬', icon: 'align-center'},
                            {key: 'right', label: '오른쪽 정렬', icon: 'align-right'}
                          ].map(o => {
                            const cur = this.metaWidget.productMetaTypeAlign || 'no';
                            const active = cur === o.key;
                            return (
                              <label key={o.key} className={`mw-page-check ${active ? 'is-checked' : ''}`}
                                     onClick={() => this.onChangeMetaInputs({target:{name:'productMetaTypeAlign', value: o.key}}, this.metaWidget)}>
                                <FeatherIcon icon={o.icon} size="16"/>
                                <span>{o.label}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>상단여백</th>
                      <td><FormInput name="marginTop" value={this.metaWidget.productListConfig.marginTop} onChange={this.onChangeProductListConfig} placeholder="0px"/></td>
                    </tr>
                    <tr>
                      <th>하단여백</th>
                      <td><FormInput name="marginBottom" value={this.metaWidget.productListConfig.marginBottom} onChange={this.onChangeProductListConfig} placeholder="0px"/></td>
                    </tr>
                    <tr>
                      <th>좌우여백</th>
                      <td><FormInput name="lrPadding" value={this.metaWidget.productListConfig.lrPadding} onChange={this.onChangeProductListConfig} placeholder="0px"/></td>
                    </tr>
                    <tr>
                      <th>부모 클래스/ID</th>
                      <td>
                        <FormInput name="parentSelector" value={this.metaWidget.productListConfig.parentSelector} onChange={this.onChangeProductListConfig} placeholder=".class-name 또는 #element-id"/>
                        <p className="text-muted mt-2">예: .product-list, #product-wrap</p>
                      </td>
                    </tr>
                    <tr>
                      <th>부모 클래스/ID(모바일)</th>
                      <td>
                        <FormInput name="parentSelectorMobile" value={this.metaWidget.productListConfig.parentSelectorMobile || ''} onChange={this.onChangeProductListConfig} placeholder="미입력 시 PC 값 사용"/>
                        <p className="text-muted mt-2">모바일에서 다른 부모 요소를 쓰는 경우 입력합니다. 미입력 시 PC 값이 적용됩니다.</p>
                      </td>
                    </tr>
                    <tr>
                      <th>위젯 삽입 위치</th>
                      <td>
                        <FormSelect name="insertPosition" value={this.metaWidget.productListConfig.insertPosition} onChange={this.onChangeProductListConfig}>
                          <option value="append">지정 요소 내부의 맨 끝에 추가</option>
                          <option value="prepend">지정 요소 내부의 맨 앞에 추가</option>
                          <option value="after">지정 요소 바로 뒤에 추가 (형제 요소)</option>
                          <option value="before">지정 요소 바로 앞에 추가 (형제 요소)</option>
                          <option value="html">지정 요소의 내용을 대체</option>
                        </FormSelect>
                      </td>
                    </tr>
                    <tr data-tour="rwc-pl-class">
                      <th>제품리스트 클래스</th>
                      <td>
                        <FormInput name="productListClass" value={this.metaWidget.productListConfig.productListClass} onChange={this.onChangeProductListConfig} placeholder=".product-item, li.item"/>
                        <p className="text-muted mt-2">개별 제품 아이템의 클래스를 입력합니다. 예: .product-item, .xans-product-listnormal</p>
                      </td>
                    </tr>
                    <tr>
                      <th>제품리스트 클래스(모바일)</th>
                      <td>
                        <FormInput name="productListClassMobile" value={this.metaWidget.productListConfig.productListClassMobile || ''} onChange={this.onChangeProductListConfig} placeholder="미입력 시 PC 값 사용"/>
                        <p className="text-muted mt-2">모바일에서 개별 제품 아이템 클래스가 다른 경우 입력합니다. 미입력 시 PC 값이 적용됩니다.</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
                </div>
                </div>
              </div>

              {/* 위젯 CSS 파일 설정 */}
              <div className={`wbp-accordion ${this.openRwcSection === 'css' ? 'is-open' : ''}`} style={{marginTop: 16}}>
                <div className="wbp-accordion__head" onClick={() => this.toggleRwcAccordion('css')}>
                  <div className="wbp-accordion__title">
                    <FeatherIcon icon="code" size="16"/>
                    <span>위젯 CSS 파일 설정</span>
                    {this.renderSectionHelp('css')}
                  </div>
                  <div className="wbp-accordion__toggle">
                    <FeatherIcon icon={this.openRwcSection === 'css' ? 'chevron-up' : 'chevron-down'} size="18"/>
                  </div>
                </div>
                <div className="wbp-accordion__body" style={{display: this.openRwcSection === 'css' ? 'block' : 'none'}}>
                <div className="section-box" style={{marginTop: 0, border: 'none', boxShadow: 'none', padding: 0}}>
                <div className="substitute-table">
                  <div className="section-tit" style={{display: 'none'}}>
                    <h3><FeatherIcon icon="code" size="18" className="section-icon"/> 위젯 CSS 파일 설정</h3>
                    <p className="section-desc">위젯에 적용할 외부 CSS 파일 링크를 입력해 주세요.</p>
                  </div>
                  <table className="s-table">
                    <colgroup>
                      <col width="170px"/>
                      <col width=""/>
                    </colgroup>
                    <tbody>
                    <tr data-tour="rwc-css-url">
                      <th>CSS 파일 URL</th>
                      <td>
                        <FormInput
                          name="widgetCssUrl"
                          value={this.basicSettings.widgetCssUrl || ''}
                          onChange={event => this.onChangeInputs(event, this.basicSettings)}
                          placeholder="https://example.com/widget.css"
                        />
                        <p className="text-muted mt-2">온리플 위젯에 추가 스타일을 적용하려면 CSS 파일 주소를 입력해 주세요.</p>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  {/* 저장은 하단 sticky-save 통합 바에서 일괄 처리 */}
                </div>
                </div>
                </div>
              </div>

              {/*<div className="section-box">*/}
              {/*  <div className="substitute-table">*/}
              {/*    <div className="section-tit">*/}
              {/*      <h3>카페24에서 상품정보 가져오기</h3>*/}
              {/*      <p>상품 정보가 변경된 경우, 원활한 관리를 위해 상품 정보를 반드시 업데이트해 주세요.</p>*/}
              {/*    </div>*/}
              {/*    <Row className="mb-4">*/}
              {/*      <Col md="6" id="reviewWriteIn_item1">*/}
              {/*        <Row>*/}
              {/*          <Col md="6">*/}
              {/*            <Button*/}
              {/*              onClick={event => this.setProductSync()}><FeatherIcon*/}
              {/*              icon="plus" size="15" className="nd-icon"/>상품 가져오기</Button>*/}
              {/*          </Col>*/}

              {/*        </Row>*/}
              {/*      </Col>*/}
              {/*    </Row>*/}

              {/*    <div className="section-tit">*/}
              {/*      <h3>카페24에서 리뷰 가져오기</h3>*/}
              {/*    </div>*/}
              {/*    <Row className="mb-4">*/}
              {/*      <Col md="6" id="reviewWriteIn_item1">*/}
              {/*        <Row>*/}
              {/*          <Col md="6">*/}
              {/*            <Button*/}
              {/*              onClick={e => this.modalToggle('isSyncReview')}><FeatherIcon*/}
              {/*              icon="plus" size="15" className="nd-icon"/>리뷰 가져오기</Button>*/}
              {/*          </Col>*/}

              {/*        </Row>*/}
              {/*      </Col>*/}
              {/*    </Row>*/}

              {/*    <div className="section-tit">*/}
              {/*      <h3>온리플 서비스 활성화/비활성화</h3>*/}
              {/*    </div>*/}
              {/*    <Row className="mb-4">*/}
              {/*      <Col md="6" id="reviewWriteIn_item1">*/}

              {/*        <Row>*/}
              {/*          <Col md="6">*/}

              {/*            <Button*/}
              {/*                onClick={e => this.modalToggle('isCafeSettingModal')}><FeatherIcon*/}
              {/*                icon="plus" size="15" className="nd-icon"/>활성화 하기</Button>*/}
              {/*          </Col>*/}
              {/*        </Row>*/}
              {/*        <Row className="mt-2">*/}
              {/*          <Col>⚠️ 중요 안내! 필수 설정을 꼭 확인하고 진행해 주세요 ⚠️</Col>*/}
              {/*        </Row>*/}
              {/*      </Col>*/}
              {/*    </Row>*/}

              {/*    <div className="section-tit notice-text">*/}
              {/*      <h3 className="text-red">활성화 후 동작이 되지 않는다면...</h3>*/}
              {/*    </div>*/}
              {/*    <Row className="mb-4 notice-text">*/}
              {/*      <Col md="6" id="reviewWriteIn_item1">*/}
              {/*        <Row>*/}
              {/*          <Col md="12">*/}
              {/*            <ul>*/}
              {/*              <li><a href="https://onnomad.notion.site/175f1bde930080bab77ee5c0d5974093?p=175f1bde9300809e85d0d4be26489a3b&pm=c" target="_blank">&#33; 상품상세페이지 기본 리뷰 리스트 코드로 넣기(사용법)</a> : &lt;div id="orp_prdReview"&gt;&lt;/div&gt;</li>*/}
              {/*              <li><a href="https://onnomad.notion.site/" target="_blank">메뉴얼보기</a></li>*/}
              {/*            </ul>*/}

              {/*          </Col>*/}
              {/*        </Row>*/}
              {/*      </Col>*/}
              {/*    </Row>*/}

              {/*  </div>*/}
              {/*</div>*/}


              <Modal size="lg" className='modal-review-write-form' open={this.modals.isCafeSettingModal}
                     toggle={() => {}} centered={true}>
                <ModalHeader>서비스 활성화/비활성화</ModalHeader>
                <ModalBody className="history-window-popup">
                  {/*<p><span className='warning-font'>* 해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.</span></p>*/}
                  <div className="history-popup-contents">
                    <div className="popup-contents-main">
                      <h4>서비스를 활성화하려면 해당 스킨의 스위치 버튼을 클릭하세요.</h4>
                      <table className="s-table">
                        <colgroup>
                          <col width="170px"/>
                          <col width=""/>
                        </colgroup>
                        <tbody>
                        <tr>
                          <th>{this.selShop ? this.selShop.shopName : ""}</th>
                          <td>
                            <Row style={{overflow: "scroll", height: "700px"}}>
                              <Col md="12">
                                <ul className="skin-list">
                                  {this.selShop && this.skins && this.skins.length > 0 ?
                                      this.skins.map((item, j) => (
                                          <li key={j}>
                                            <FormCheckbox toggle small checked={item.isSetScript}
                                                          onChange={event => this.onChangeCheckedforApplySkin(event, item, ['isSetScript'])}>
                                              [{item.usage_type === 'S' || item.usage_type === 'C' || item.usage_type === 'I' ? "PC" : ""}{item.usage_type === 'M' || item.usage_type === 'N' ? "모바일" : ""}]{item.skin_name}/{skinLanguageCodeKR(item.language_code)}
                                              <strong className="warning-font">{item.skin_no === this.selShop.pcSkinNo ? " - PC 사용스킨" : (item.skin_no === this.selShop.mobileSkinNo ? " - 모바일 사용스킨" : "") }</strong>
                                            </FormCheckbox>
                                          </li>
                                      ))
                                      : null
                                  }
                                </ul>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="text-right">
                                <Button className="save-button" onClick={event => this.getApplySkins(true)}>스킨 리스트
                                  업데이트</Button>
                              </Col>
                            </Row>
                          </td>
                        </tr>
                        {/*<tr>*/}
                        {/*  <th>리뷰 게시판 ID</th>*/}
                        {/*  <td>*/}
                        {/*    <InputGroup><FormInput value={this.store.cafe24UseReviewBoardNo} id="cafe24UseReviewBoardNo"*/}
                        {/*                           name="cafe24UseReviewBoardNo" className="text-center"*/}
                        {/*                           onChange={event => this.onChangeInputs(event, this.store)}*/}
                        {/*                           type="number"*/}
                        {/*                           placeholder="초기 셋팅 id는 4입니다."/></InputGroup>*/}
                        {/*  </td>*/}
                        {/*</tr>*/}
                        {/*<tr>
                          <th>카페24 리뷰 가져오기</th>
                          {this.reviewCount && this.reviewCount.review === 0 && this.reviewCount.reviewScore === 0 ? (
                              <td className="text-left"><Button id="getPlatformReview" size="sm"
                                                                onClick={event => this.setReviewSync('import')}>카페24 리뷰
                                가져오기</Button>(* 온리플에서 작성된 모든 리뷰데이터가 삭제되니 주의부탁 드립니다.)</td>
                          ) : <td className="text-left"><span className="text-primary">카페24 리뷰는 처음 시작할때 또는 기존 리뷰데이터를 초기화 후 사용이 가능합니다.</span><Button
                              className="ml-2" size="sm" onClick={event => this.initReviewData()}>리뷰데이터 초기화</Button></td>}
                        </tr>
                        {this.reviewCount && this.reviewCount.review === 0 && this.reviewCount.reviewScore === 0 ? (
                            <tr>
                              <th>카페24 리뷰 내보내기 해당 기능은 슈퍼관리자로 이동</th>
                              <td className="text-left"><Button size="sm" onClick={event => this.setReviewSync('export')}>카페24
                                리뷰 내보내기</Button>(* 온리플에서 작성된 모든 리뷰가 카페24 리뷰 게시판으로 데이터를 전달됩니다.)
                              </td>
                            </tr>
                        ) : null}*/}
                        {/*{this.teamUser.emailId === "admin@onnomads.com" ? (*/}
                        {/*    <tr>*/}
                        {/*      <th>리뷰데이터 리셋</th>*/}

                        {/*    </tr>*/}
                        {/*) : null}*/}
                        </tbody>
                      </table>
                    </div>


                    <div className="text-center">
                      {/*<Button onClick={event => this.updateReview(this.modals.widgetData)}>리뷰작성</Button>*/}
                      <Button className="ml-2" theme="light"
                              onClick={event => this.modals.isCafeSettingModal = false}>닫기</Button>
                    </div>
                  </div>

                </ModalBody>
              </Modal>

              <Modal size="lg" className='modal-review-synk-form' open={this.modals.isSyncReview}
                     toggle={() => {}} centered={true}>
                <ModalHeader>리뷰 가져오기</ModalHeader>
                <ModalBody className="history-window-popup">
                  {/*<p><span className='warning-font'>* 해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.</span></p>*/}
                  <div className="history-popup-contents">
                    <div className="popup-contents-main">

                      <h4 className="mt-2">작성시간 ({'최대 ' + this.serarchPeriod[2] + '단위로 선택해 주세요.'})</h4>
                      <Row>
                        <Col md="5">
                          <div className="calendar-box">
                            <div className="calendar-wrap">
                              <FormInput disabled={this.isWidgetMode} name="startDate" placeholder=""
                                         onChange={event => {
                                           this.onChangeSyncReviewValue(event)
                                         }} value={this.syncReviewValue.startDate} onClick={() => {
                                this.isShowCalendarForRS.endDate = false;
                                this.isShowCalendarForRS.startDate = !this.isShowCalendarForRS.startDate;
                              }} className="table-input-text search-calendar star"/>
                              {this.isShowCalendarForRS.startDate ? (
                                  <Calendar value={moment(this.syncReviewValue.startDate).toDate()}
                                            className="startDate"
                                            onChange={date => {
                                              this.onChangeCalendarValueForRS(date, 'startDate')
                                            }} maxDate={new Date()}/>) : null}
                            </div>
                          </div>
                        </Col>
                        <Col md="1" className="text-center bt-symbol">&#126;</Col>
                        <Col md="5">
                          <div className="calendar-wrap">
                            <FormInput disabled={this.isWidgetMode} name="endDate" placeholder="" onChange={event => {
                              this.onChangeSyncReviewValue(event)
                            }} value={this.syncReviewValue.endDate} onClick={() => {
                              this.isShowCalendarForRS.startDate = false;
                              this.isShowCalendarForRS.endDate = !this.isShowCalendarForRS.endDate;
                            }} className="search-calendar end"/>
                            {this.isShowCalendarForRS.endDate ? (
                                <Calendar value={moment(this.syncReviewValue.startDate).toDate()} className="endDate"
                                          onChange={date => {
                                            this.onChangeCalendarValueForRS(date, 'endDate')
                                          }} maxDate={new Date()}/>) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col className="text-left">
                          <Button onClick={event => {
                            this.syncReviewValue.startDate = moment(this.syncReviewValue.startDate).add(-this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                            this.syncReviewValue.endDate = moment(this.syncReviewValue.endDate).add(-this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                          }}><FeatherIcon
                              icon="chevron-left" size="16" className="nd-icon"/>{this.serarchPeriod[2]} 이전</Button>
                          <Button className="ml-3" onClick={event => {
                            this.syncReviewValue.startDate = moment(this.syncReviewValue.startDate).add(this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                            this.syncReviewValue.endDate = moment(this.syncReviewValue.endDate).add(this.serarchPeriod[0], this.serarchPeriod[1]).format('YYYY-MM-DD');
                          }}>{this.serarchPeriod[2]} 다음<FeatherIcon
                              icon="chevron-right" size="16" className="nd-icon"/></Button>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <ButtonGroup>
                          <Button onClick={e => this.selectPeriod(1, "days")} className="ml-3" theme="light">1일</Button>
                          <Button onClick={e => this.selectPeriod(2, "days")} className="ml-2" theme="light">2일</Button>
                          <Button onClick={e => this.selectPeriod(1, "weeks")} className="ml-2" theme="light">7일</Button>
                          <Button onClick={e => this.selectPeriod(2, "weeks")} className="ml-2" theme="light">2주</Button>
                          <Button onClick={e => this.selectPeriod(1, "months")} className="ml-2" theme="light">1달</Button>
                          <Button onClick={e => this.selectPeriod(1, "max")} className="ml-2" theme="light">최대</Button>
                        </ButtonGroup>
                      </Row>
                      <h4 className="mt-2">추가 방법(기존리뷰 데이터 처리 방식)</h4>
                      <Row>
                        <Col md="12">
                          <FormCheckbox toggle name="isOverwrite" checked={this.syncReviewValue.isOverwrite}
                                        onChange={event => {
                                          this.syncReviewValue.isOverwrite = !this.syncReviewValue.isOverwrite
                                        }} value={this.syncReviewValue.isOverwrite}>
                            {this.syncReviewValue.isOverwrite ? '기존 리뷰 덮어쓰기(카페24 데이터 구조)' : '기존 리뷰는 변경 없이, 새로운 리뷰민 추가'}
                          </FormCheckbox>
                        </Col>
                      </Row>
                      <Row className="mt-5">
                        {this.syncReviewValue.isOverwrite ?
                            (<Col md="12" className="text-red text-center text-notice"><strong>주의! 온리플에서 작성된 리뷰와 댓글 모두 카페24의 데이터로 덮어쓰기가 됩니다.</strong></Col>) :
                            (<Col md="12" className="text-red text-center text-notice"><strong>기존 리뷰는 변경 없이, 카페24에 추가된 리뷰만 가져옵니다.</strong></Col>)}
                      </Row>

                    </div>
                    <div className="text-center">
                      <Button onClick={event => this.setReviewSync('period')}>리뷰가져오기</Button>
                      <Button className="ml-2" theme="light" onClick={event => this.modals.isSyncReview = false}>닫기</Button>
                    </div>
                  </div>

                </ModalBody>
              </Modal>

              <Modal size="lg" className='modal-board-capacity-guide' open={this.modals.isBoardCapacityGuide}
                     toggle={() => this.modals.isBoardCapacityGuide = !this.modals.isBoardCapacityGuide} centered={true}>
                <ModalHeader>카페24 자료실 게시판 용량 확인 안내</ModalHeader>
                <ModalBody>
                  <div className="board-capacity-guide">
                    <p className="board-capacity-guide__lead">
                      카페24 쇼핑몰 관리자 페이지에서 <strong>자료실 게시판 용량 현황</strong>의 사용가능 공간을 반드시 확인해 주세요.
                      해당 공간이 부족하면 리뷰 이미지/첨부파일이 카페24에 정상적으로 저장되지 않아 리뷰 작성이 실패할 수 있습니다.
                    </p>

                    <h5 className="mt-3">확인 경로</h5>
                    <ol className="board-capacity-guide__steps">
                      <li>카페24 쇼핑몰 관리자(EC) 로그인</li>
                      <li>좌측 메뉴 <strong>게시판 &gt; 게시판 관리 &gt; 자료실 게시판 용량 현황</strong> 진입</li>
                      <li>현재 사용량 / 사용가능 공간 확인</li>
                    </ol>

                    <div className="board-capacity-guide__img-wrap">
                      <img src={boardDataCheckImg} alt="카페24 자료실 게시판 용량 현황 화면 예시"
                           className="board-capacity-guide__img"/>
                    </div>

                    <h5 className="mt-3">사용가능 공간이 부족한 경우</h5>
                    <ul className="board-capacity-guide__tips">
                      <li>카페24 자료실에서 불필요한 첨부파일을 정리하거나, 자료실 용량 추가 상품을 결제해 주세요.</li>
                      <li>용량 확보 후 리뷰 작성을 다시 시도하면 정상적으로 카페24에 등록됩니다.</li>
                    </ul>

                    <div className="text-center mt-4">
                      <Button theme="light" onClick={() => this.modals.isBoardCapacityGuide = false}>닫기</Button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>

              <ModalLoading isLoading={this.isLoading}/>

              {/* === 통합 Sticky 저장 바 (basicSettings/metaWidget 변경 시 노출 / 상단 고정 레이어) === */}
              {(this.basicSettingsDirty || this.metaWidgetDirty) && (
                <div className="wbp-sticky-save wbp-sticky-save--top">
                  <div className="wbp-sticky-save__msg">
                    <FeatherIcon icon="alert-circle" size="16"/>
                    <span>저장되지 않은 변경사항이 있습니다.</span>
                    <span className="wbp-sticky-save__tags">
                      {this.basicSettingsDirty && <span className="wbp-sticky-save__tag">리뷰 작성 설정</span>}
                      {this.metaWidgetDirty && <span className="wbp-sticky-save__tag">제품 리스트 설정</span>}
                    </span>
                  </div>
                  <div className="wbp-sticky-save__actions">
                    <Button theme="light" size="sm" onClick={() => this.revertAllSettings()}>되돌리기</Button>
                    <Button theme="primary" size="sm" onClick={(e) => this.saveAllSettings(e)}>
                      <FeatherIcon icon="save" size="13"/> 변경사항 저장
                    </Button>
                  </div>
                </div>
              )}
            </div>
            :
            null
          }
        </div>


      </>
    )
  }
}

export default ReviewWriteConfig;
